<!--
@Author: Calvin Green <calvin>
@Date:   2022-01-12T09:57:12+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T10:33:41+02:00
@Copyright: Diversitude 2021
-->



<template>
    <!--
    <b-card>
        <b-button variant="info" @click="$emit('back')">
            <i class="fas fa-arrow-left"></i>
        </b-button>
    </b-card>
    -->
    <div>
        <b-row v-show="show_pdf == false">
            <b-col v-if="isNewDocument" cols="12">
                <b-card>
                    <b-alert :show="true" variant="light">Add a document title</b-alert>
                </b-card>
            </b-col>
            <b-col cols="12" v-if="isNewDocument == false">
                <b-card class="revisions-bar">
                    <span class="roundIcon" :style="revision.published == 1 ? 'color: #05B15F !important;':''" style="font-size: 1.8rem;" v-for="(revision, index) in sop_revisions" @click="selectRevision(index)" :key="index" :title="revision.published == 1 ? 'Published' : 'Draft'" >
                        <!--<i v-if="index != 0" class="fas fa-minus"></i>-->
                        <span v-if="index != 0">-</span>
                        <i v-if="isRevisionSelected(index)" class="fas fa-check-circle"></i>
                        <i v-else class="fas fa-circle"></i><!-- v-if="index == selected_revision_index" -->
                    </span>
                    <div v-if="sop_revisions.length == 0">
                        <b-alert class="m-0" :show="true">
                            No Revision History
                        </b-alert>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="10" md="9" >
                <b-card no-body v-if="isNewDocument == false" class="p-1">
                    <!-- -- -- -- -->
                    <div v-if="edit_section != null && isEditableSection">
                        <b-row>
                            <b-col cols="12" class="mt-2 pt-1">
                                <div class="d-flex ps-3 pe-3 pb-2 ">
                                    <div class="card-title" for="">Section Title:</div>
                                    <b-form-input size="lg" v-if="sections != null" v-model="sections[edit_section].section_title">

                                    </b-form-input>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <EditorWrapper v-if="finishedLoading && isEditableSection" @updatedSection="updateSectionText" :type="edit_section" :readOnly="isNewDocument" :text="display_data" :b64="b64" :revision="sop_data.revisions[selected_revision_index]"/>

                    <Attachments v-if="finishedLoading && !isEditableSection" />
                    <b-overlay :show="is_loading_pdf"></b-overlay>
                </b-card>
            </b-col>
            <b-col cols="2" md="3">
                <!-- checklist component -->
                <!--
                <CheckList v-if="isNewDocument" />
                -->


                <div class="card">
                    <div style="text-align: center;" class="card-heading-text bg-green card-text p-2 mb-0">
                        <i style="position:relative; float:left; font-size:14px; cursor: pointer;" @click="addSection()" class="fa fa-plus"></i>
                        HEADINGS
                        <!-- <i style="position:relative; float:right; font-size:14px; cursor: pointer;" @click="edit_section = null;" v-if="edit_section != null" class="fa fa-times"></i> -->
                    </div>
                    <b-overlay :show="isLoading">
                        <b-list-group class="headings-list">
                            <!-- isActiveGroup -->
                            <b-list-group-item v-for="(value, key) in sections" v-bind:key="key" :active="isActiveGroup(key)" @click="editHeading(key)">
                                {{ value.section_title }}
                                <i v-show="value.type != 'attachments_annexures' && value.type != 'attachments'" style="position:relative; float:right; font-size:14px;" @click.stop="removeSection(key)" class="fa fa-times"></i> 
                            </b-list-group-item>
                        </b-list-group>
                    </b-overlay>
                    <b-button @click="edit_section = null;" style="width: 100%;">Clear Selection</b-button>
                </div>

                <div v-if="isNewDocument">
                    <div @click="saveNewSopType" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Save Draft</p>
                    </div>
                    <div class="save-btn mt-3 p-2">
                        <p class="inner-btn">Continue</p>
                    </div>
                </div>
                <div v-else>
                    <div @click="showPreview" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Preview</p>
                    </div>
                    <div @click="saveRevision()" class="save-btn mt-3 p-2">
                        <p class="inner-btn">Save</p>
                    </div>
                    <div class="pub-btn mt-3 p-2" @click="showPublishPrompt">
                        <p class="inner-btn" v-if="isPublishing">
                            <i class="fas fa-spinner fa-spin"></i>
                        </p>
                        <p v-else class="inner-btn">Publish</p>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row v-if="show_pdf">
            <b-col cols="12">
                <div class="">
                    <b-overlay style="min-height: 15rem;" :show="is_loading_pdf">
                        <b-button variant="primary" @click="show_pdf = false; b64 = null;">Close</b-button>
                        <div v-if="b64 != null" >
                            <iframe :src="b64 + '#toolbar=0'" style="width: 100%; height: 80vh;"></iframe>
                        </div>
                    </b-overlay>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { sopAdminState, sopAdminMethods} from '@/state/helpers.js'
import _ from 'lodash';
import EditorWrapper from './editor-wrapper.vue'
import DisplayWrapper from './editor-wrapper.vue'
import Attachments from './attachment-editor.vue'
import CheckList from './sopChecklist.vue'

import Swal from 'sweetalert2'

import {layoutMethods} from '@/state/helpers';
export default {
    props:{
        isNewDocument:{}
    },
    data:() => ({
        isPublishing: false,
        show_pdf: false,
        is_loading_pdf: false,
        b64: null,

        finishedLoading: false,
        edit_item: null,
        edit_section: null,
        isLoading: false,
        revision_data: null,
        selected_revision_index: null,
        section_names: [
            ['list_of_abbreviations', ''],
            ['objective', ''],
            ['scope', ''],
            ['responsibility', ''],
            ['policy', ''],
            ['procedure', ''],
            ['attachments_annexures', '']],
        sections: [],
        document_details:{
            title: '',
        },
    }),
    components:{
        EditorWrapper,
        //eslint-disable-next-line
        DisplayWrapper,
        Attachments,
        //eslint-disable-next-line
        CheckList,
    },
    computed:{
        ...sopAdminState,
        sop_revisions(){
            if(this.sop_data != null){
                return this.sop_data.revisions;
            }
            else{
                return [];
            }
        },
        display_data(){
            let data = '';
            if(this.edit_section == null){
                data = this.full_document;
            }
            else{
                //data = this.document_data[this.edit_section].body
                data = this.sections[this.edit_section].body
            }
            return data;
        },
        full_document(){
            //* create full document by inserting each sections TITLE and BODY
            let doc = '';
            _.forEach(this.sections, function(value) {
                if (value.type != "attachments_annexures" && value.type != "attachments") {
                    doc += `<h1>${value.section_title}</h1>`
                    doc += value.body;
                }
            });
            return doc;
        },
        isEditableSection(){
            if (this.edit_section != null && (this.sections[this.edit_section].type == "attachments_annexures" || this.sections[this.edit_section].type == "attachments")) {
                return false;
            }
            return true;
        },
        showCollpase:{
            get:function(){
                return this.edit_section != null;
            },
            set:function(){
                console.log('Collpase menu toggle')
            }
        }
    },
    methods:{
        ...layoutMethods,
        ...sopAdminMethods,
        logRefs(){
            console.log(this);
        },
        blobToBase64(file) {
            return new Promise((resolve) => {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    console.log(reader.result);
                    resolve(reader.result);
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                };
            })
        },
        saveNewSopType(){
            let name = document.getElementById("sopTitle").value
            let params = {
                id: -1,
                sop_group_id: this.selected_sop_group,
                name: name,
                sop_code: 'SOP-00'
            }
            this.saveSopType(params)
            .then((response)=>{
                this.loadSops(this.selected_sop_group);
                this.saveRevision(response.id);
                //this.$emit('handleNewSOP');
                //this.loadSopData(this.sop_data.id);
                this.$emit('back');
                this.updateMenuType({
                    type: 'documents',
                    showMenu: true,
                    showRoutes: false,
                })
            })
            //console.log(this.$refs['titleInput']);
        },
        removeSection(key) {
            if (this.sections[key].type == "attachments_annexures" || this.sections[key].type == "attachments") {
                return;
            }
            this.sections.splice(key, 1);
        },
        addSection() {
            var sectionData = {
                type: "new_section",
                body: "<p></p>",
                section_title: "New Section",
                content_height: 0,
            };
            var length = this.sections.length;
            var sectionIndex;
            if (length == 0) {
                sectionIndex = 0;
            } else if (length == 1) {
                sectionIndex = 0;
            } else {
                sectionIndex = length - 1;
            }
            this.sections.splice(sectionIndex, 0, sectionData);
        },
        isSelected(type){
            if(type === this.edit_section){
                return 'font-weight: bold;'
            }
            else{
                return '';
            }
        },
        isActiveGroup(key){
            if(key === this.edit_section){
                return true;
            }
            else{
                return false;
            }
        },
        isRevisionSelected(index){
            let valid = false;
            if(index == this.selected_revision_index){
                valid = true;
            }
            return valid;
        },
        editHeading(key){
            //this.isLoading = true;
            setTimeout(()=>{
                //this.isLoading = false;
            }, 1000);
            this.$nextTick(()=>{
                this.edit_section = key;
            })
        },
        editBody(type){
            this.edit_section = null;
            this.$nextTick(()=>{
                this.edit_section = type;
            })
        },
        setSopDisplayData(){
            document.getElementById("sopTitle").value = this.sop_data.name;
            document.getElementById("sopAuthor").value = this.sop_revisions[this.selected_revision_index].last_edit_user_name;
            document.getElementById("sopIssueDate").value = this.sop_revisions[this.selected_revision_index].created_at;
            document.getElementById("sopRevisionNumber").value = this.sop_revisions[this.selected_revision_index].revision_no;

        },
        insertBlankRevision(){
            this.section_names.forEach((section)=>{
                let name = section[0];
                let body = section[1];
                var sectionData = {
                    type: name,
                    body: body,
                    section_title: '',
                }
                this.sections.push(sectionData);
            });
            this.revision_data = [];
            this.revision_data.push(this.section_names);
            this.selected_revision_index = 0;
            this.$nextTick(()=>{ this.finishedLoading = true; })
        },
        saveRevision(id = null){
            setTimeout(() => {
                console.log("saving");
                var params = {
                    sop_type_id: (id == null ? this.sop_data.id : id),
                    sections: []
                };

                var sectionData = {};
                var sectionIndex = 1;
                _.forEach(this.sections, function (value) {
                    sectionData = {
                        section_id: _.snakeCase(value.section_title),
                        section_order: sectionIndex,
                        body: value.body,
                        section_title: value.section_title,
                        content_height: value.content_height,
                    };
                    sectionIndex++;
                    params.sections.push(sectionData);
                });

                if (id != null) {
                    params.sections = [];
                }

                this.saveSopRevision(params)
                    .then(() => {
                        Swal.fire({
                            toast: true,
                            position: 'top',
                            iconColor: 'white',
                            icon: 'success',
                            title: 'Revision saved!',
                            customClass: { popup: 'success-toast' },
                            showConfirmButton: false,
                            timer: 1500,
                            //timer: 2000, timerProgressBar: true
                        });
                        if (id == null) {
                            //* only load  if the sop_data object exists
                            this.loadSopData(this.sop_data.id)
                                .then(() => {
                                    let idx = this.sop_data.revisions.length - 1;
                                    this.selectRevision(idx);

                                });
                        }

                    })
            }, 500);
        },
        publishRevision(){
            this.isPublishing = true;
            let params = {
                revision_id: this.revision_data.revision_id
            }
            this.publishSop(params)
            .then(()=>{
                Swal.fire({
                    toast: true,
                    position: 'top',
                    iconColor: 'white',
                    icon: 'success',
                    title:'Success!',
                    customClass: {     popup: 'success-toast' },
                    showConfirmButton: false,
                    timer: 1500,
                    //timer: 2000, timerProgressBar: true
                });
                this.loadSopData(this.sop_data.id);
                this.isPublishing = false;
            })
        },
        showPublishPrompt() {
            if(this.revision_data.published == 1){
                Swal.fire({
                    title: "This revision is already published.",
                    text: "",
                    icon: "info",
                    showCancelButton: false,
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "OK",
                });
            }
            else{
                Swal.fire({
                    title: "Publish this revision?",
                    text: "",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes",
                }).then((result) => {
                    if (result.value) {
                        this.publishRevision();
                    }
                });
            }
        },
        selectRevision(index){
            var el = this;
            this.b64 = null;
            //this.edit_section = null;
            this.revision_data = _.cloneDeep(this.sop_revisions[index]);
            this.selected_revision_index = index;
            if(this.revision_data.published == 1){
                this.is_loading_pdf = true;
                window.axios({
                    url: 'api/ccbdocadmin/b64preview/' + this.revision_data.revision_id,
                    method: 'GET',
                    responseType: 'blob',
                })
                .then(async (response) => {
                    this.b64 = window.URL.createObjectURL(response.data);
                    this.is_loading_pdf = false;
                }).catch(() => {
                    this.is_loading_pdf = false;
                });
            }
            else if(this.revision_data.published == 0 && this.revision_data.s3_cache_src != null){
                this.is_loading_pdf = true;
                window.axios.get('api/ccbdocadmin/soppreview/' + this.revision_data.revision_id)
                .then( (response) =>{
                    this.is_loading_pdf = false;
                    this.b64 = response.data.temp_url;
                })
                .catch((error)=>{
                    this.is_loading_pdf = false;
                    console.log(error)
                })
            }

            //* Extract sections from array
            this.$nextTick(()=>{
                this.sections = [];
                var sectionData;
                _.forEach(this.revision_data.sections, function(value) {
                    sectionData = {
                        type: _.snakeCase(value.section_title),
                        body: value.body,
                        section_title: value.section_title,
                        content_height: value.content_height,
                    };
                    el.sections.push(sectionData);
                });

                this.finishedLoading = true;
                this.$nextTick(()=>{
                    //this.setSopDisplayData(); -- old dumb way --
                    //*emit revision data to edit-documents left menu component
                    let payload = {
                        title: this.sop_data.name,
                        author: this.sop_revisions[this.selected_revision_index].last_edit_user_name,
                        issue_date: this.sop_revisions[this.selected_revision_index].created_at,
                        revision: this.sop_revisions[this.selected_revision_index].revision_no,
                    }
                    this.$eventHub.$emit('updatedRevisionData', payload);
                })
            })
        },
        updateSectionText(data){
            if(this.edit_section != null){
                //todo - add sweet alert popup if changes were made
                //this.has_made_changes = true
                this.sections[this.edit_section].body = data.text;
                this.sections[this.edit_section].content_height = data.height;
            }
        },
        // show context menu
        showEditMenu(){
            this.updateMenuType({
                type: 'document_edit',
                showMenu: false,
                showRoutes: false,
            });
        },
        showPreview(){
            this.show_pdf = true;
            this.is_loading_pdf = true;

            let params = {
                revision_id: this.revision_data.revision_id,
            }
            window.axios({
                url: 'api/ccbdocadmin/previewsop',
                method: 'POST',
                data: params,
                responseType: 'blob',
            })
            .then((response) => {
                this.b64 = window.URL.createObjectURL(response.data);
                this.is_loading_pdf = false;
            }).catch(() => {
                this.is_loading_pdf = false;
            });
        }
    },
    mounted(){
        if (this.sop_revisions.length > 0) {
            this.selectRevision(this.sop_revisions.length - 1);
        } else {
            this.insertBlankRevision();
        }
    },
}
</script>

<style>
.roundIcon{
    color:darkorange;
    transition: all 0.3s linear;
}
.roundIcon:hover{
    color:rgb(0, 0, 0);
    transition: all 0.2s linear;
}


.headings-list>li{
    text-decoration: underline;
    cursor: pointer;
}


.inner-btn{
    padding-top: 0.4rem;
    margin-bottom: 0.2rem;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 1.6rem;/*28px;*/
    line-height: 18px;
    color: #FFFFFF;
    text-align: center;
}
.save-btn{
    background-image: linear-gradient(to right, #56CCF2 0%, #2F80ED  51%, #56CCF2  100%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    border-radius: 10px;
    display: block;
}

.save-btn:hover{
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

.pub-btn{
    cursor: pointer;
    background: radial-gradient(90.79% 1306.93% at 74.93% 34.21%, #B1B1B1 0%, #8D8D8D 100%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    transition: all 0.2s linear;
}
.pub-btn:hover{
    background: radial-gradient(74.93% 34.21% at 90.79% 1306.93%, #B1B1B1 0%, #8D8D8D 100%);
    border-radius: 20px;
    transition: all 0.2s linear;
}
</style>
